// @ts-nocheck
/**
 * Size of RIPEMD160 hash in bytes (160 bits)
 *
 * @see https://voltaire.tevm.sh/crypto for crypto documentation
 * @since 0.0.0
 * @throws {never}
 * @example
 * ```javascript
 * import { SIZE } from './crypto/Ripemd160/index.js';
 * console.log(SIZE); // 20
 * ```
 */
export const SIZE = 20;

/**
 * Size of RIPEMD160 hash in hex characters (without 0x prefix)
 *
 * @see https://voltaire.tevm.sh/crypto for crypto documentation
 * @since 0.0.0
 * @throws {never}
 * @example
 * ```javascript
 * import { HEX_SIZE } from './crypto/Ripemd160/index.js';
 * console.log(HEX_SIZE); // 40
 * ```
 */
export const HEX_SIZE = 40;
